<template>
  <tg-layout>
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch">
        <tg-dropdown
          :autoWidth="false"
          :items="filters"
          @on-change="handleFilterChange"
          trigger="click"
        >
          <template slot="icon">
            <i class="tg-icon tg-icon-notlogin"></i>
          </template>
        </tg-dropdown>
        <el-input
          :placeholder="$t('component.form.input.placeholder.agent')"
          v-model="searchName"
          class="tg-input col-2"
          size="small"
          clearable
        ></el-input>
      </tg-search-tool>
    </template>
    <el-row type="flex" justify="start" style="height: 100%;" :gutter="15">
      <el-col :span="6" class="level-distributed--agent">
        <tg-table
          ref="table"
          :columns="columns"
          :proxy="proxy"
          align="center"
          :fit="true"
          @on-loaded="handleLoaded"
          :tableHeight="669"
        >
          <template slot="header.username">{{
            $t("column." + this.groupTag + "_account")
          }}</template>
          <template slot="userfullname" slot-scope="scope">
            <tg-user-full-name
              v-bind="scope"
              :class="{
                'as-link':
                  scope.row.total_tg_business_num > 0 && scope.row.group > 20,
              }"
              @click.native="
                scope.row.total_tg_business_num > 0 && scope.row.group > 20
                  ? updateAgentTable(scope.row)
                  : null
              "
            ></tg-user-full-name>
          </template>
          <template slot="people_num" slot-scope="scope">
            <span
              :class="{ 'as-link': scope.value > 0 }"
              @click="scope.value > 0 ? updateDistributed(scope.row) : null"
              >{{ scope.value }}</span
            >
          </template>
        </tg-table>
      </el-col>
      <el-col :span="5" v-if="showDistributed">
        <tg-table
          ref="numTable"
          :columns="numColumns"
          :proxy="numProxy"
          align="center"
          :fit="true"
          @on-loaded="handNumleLoaded"
          showSummary
          :summary-method="parseSummary"
        >
          <!-- <template slot="header.username">
              <span>Lv.{{level}} {{$t('column.member')}}</span>
          </template>-->
          <template slot="num" slot-scope="scope">
            <span
              :class="{ 'as-link': scope.value > 0 }"
              @click="
                scope.value > 0 ? handleDistribuedClick(scope.row.lv) : null
              "
              >{{ scope.value }}</span
            >
          </template>
        </tg-table>
      </el-col>
      <el-col :span="13" v-if="showMember" class="level-distributed--member">
        <tg-table
          ref="peopleTable"
          :columns="memberColumns"
          :proxy="peopleProxy"
          align="center"
          :fit="true"
          showPagination
        >
          <!-- <template slot="header.username">
              <span>Lv.{{level}} {{$t('column.member')}}</span>
          </template>-->
          <template slot="userfullname" slot-scope="scope">
            <tg-user-full-name v-bind="scope"></tg-user-full-name>
          </template>
        </tg-table>
      </el-col>
    </el-row>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgSearchTool from "@/components/tool/TgSearchTool";

import formatter from "@/utils/formatter";

import apis from "@/apis";
const api = apis.tg_business.level_distributed;
import { summary } from "@/utils/table";

export default {
  components: {
    TgLayout,
    TgTable,
    TgUserFullName,
    TgDropdown,
    TgSearchTool,
  },
  data() {
    return {
      loading: false,
      columns: [],
      memberColumns: [],
      proxy: api.getData,
      groupTag: "",
      targetName: "",
      targetGroup: "",
      hasAgentData: true,
      agentName: "",
      agentGroup: "",
      showDistributed: false,
      distributed: [],
      level: null,
      showMember: false,
      searchName: "",
      peopleProxy: api.getMember,

      filter: null,
      showUpperAgent: false,
      numColumns: [],
      numProxy: api.getDistributed,
    };
  },
  props: {
    hasUser: Boolean,
  },
  created() {
    this.targetName = this.$route.params.username;

    api.getColumns().then(({ data }) => {
      let columns = data.columns;
      columns[0].renderHeader = this.renderAgentHeader;
      columns[0].children[0].renderHeader = this.renderUsernameHeader;
      this.columns = columns;
      let memberColumns = data.memberColumns;
      memberColumns[0].renderHeader = this.renderLvHeader;
      this.memberColumns = memberColumns;
      let numColumns = data.numColumns;
      numColumns[0].renderHeader = this.renderNumHeader;
      this.numColumns = numColumns;
      this.$nextTick(() => {
        this.$refs.table.init(this.agentTableRequest);
      });
    });
  },
  computed: {
    loadingLabel() {
      return this.$t("component.table.loading", "資料查詢中...");
    },
    computedFilter() {
      return !this.filter ? 0 : this.filter.value;
    },
    targetGroupComputed() {
      return this.targetGroup || "l" + this.$user.group;
    },
    targetNameComputed() {
      return this.targetName || this.$user.id;
    },
    agentTableRequest() {
      return {
        filter: this.computedFilter,
        targetName: this.targetNameComputed,
        searchName: this.searchName,
      };
    },
    distributedRequest() {
      if (!this.hasUser) {
        return {
          username: this.$user.id,
          group: this.$user.group,
        };
      } else {
        return {
          username: this.targetNameComputed,
          group: this.targetGroupComputed.slice(1),
        };
      }
      // return {
      //   username: this.agentName,
      //   group: this.agentGroup
      // };
    },
    memberRequest() {
      return {
        targetName: this.agentName,
        level: this.level,
        filter: this.computedFilter,
      };
    },
    filters() {
      return [
        {
          label: this.$t("enum.level_filter[0]"),
          value: 0,
          active: true,
        },
        {
          label: this.$t("enum.level_filter[1]"),
          value: 1,
        },
        {
          label: this.$t("enum.level_filter[2]"),
          value: 2,
        },
      ];
    },
  },
  methods: {
    renderNumHeader(h) {
      return h(
        "span",
        this.$t("column.l" + this.agentGroup) + "(" + this.agentName + ")"
      );
    },
    renderAgentHeader(h) {
      let col = this.columns[0];
      let lang = "column." + col.langKey;

      if (!this.showUpperAgent) {
        return h("span", this.$t(lang));
      }

      return h(
        "span",

        [
          this.$t(lang),
          " - ",
          h(
            "span",
            {
              class: [],
              // on: {
              //   click: () => {
              //     this.updateDistributed({
              //       username: this.targetNameComputed,
              //       group: this.targetGroupComputed.slice(1),
              //     });
              //   },
              // },
            },
            this.$t("column." + this.targetGroupComputed) +
              "(" +
              this.targetNameComputed +
              ")"
          ),
        ]
      );
    },
    renderUsernameHeader(h, { column }) {
      let col = this.columns[0].children.find(
        (x) => x.name == column.columnKey
      );

      let lang = this.groupTag ? this.groupTag + "_account" : col.langKey;
      return h("span", this.$t("column." + lang));
    },
    renderLvHeader(h) {
      return h("span", "Lv." + this.level + "  " + this.$t("column.member"));
    },
    handleLoaded(response) {
      if(response.retcode == 0){
        this.groupTag = response.groupTag;
        this.targetGroup = response.upperGroupTag;
        this.hasAgentData = response.data.length > 0;
        this.$nextTick(() => {
          if (this.targetName && !this.searchName) {
            this.addBreadcrumb();
          }
          this.showMember = false;

          // 當沒有資料時，關閉其他資料表
          // 並不顯示上層通路的按鈕
          if (!this.hasAgentData) {
            this.showDistributed = false;
            this.showUpperAgent = false;
          } else {
            this.showUpperAgent = !this.searchName;
            this.showDistributed = !this.searchName;

            // 非查詢狀態才更新等級分佈表
            if (!this.searchName) {
              this.$nextTick(() => {
                this.updateDistributed(this.distributedRequest);
              });
            }
          }
        });
      }
    },
    updateAgentTable(row) {
      if (row["total_tg_business_num"] > 0) {
        // 顯示下層資料，移除查詢訊息
        this.searchName = "";

        if (this.targetName == row.username) {
          this.$nextTick(() => {
            this.$refs.table.search(this.agentTableRequest);
          });
        } else {
          this.$router.push({
            name: "tg_business.level-distributed.user",
            params: {
              username: row.username,
            },
          });
        }
      }
    },
    parseSummary({ data }) {
      return summary(
        this.numColumns,
        data,
        this.$t("component.table.summary"),
        0
      );
    },
    handNumleLoaded(response) {
      if(response.retcode == 0){
        this.distributed = response.data;
        this.sum = response.sum;
      }
    },
    updateDistributed(row) {
      this.showMember = false;
      this.showDistributed = this.$theme == 'dark-purple' ? false : true;
      if (this.$theme != 'dark-purple') {
        this.$nextTick(() => {
          this.$refs.numTable.search({
            targetName: row["username"],
            filter: this.computedFilter,
          });
        });
      }
      
      this.agentName = row["username"];
      this.agentGroup = row["group"];
    },
    parseTotal(lv) {
      return !this.sum
        ? ""
        : formatter.format((this.distributed[lv] || 0) / this.sum, "percent");
    },
    handleDistribuedClick(lv) {
      this.level = lv;
      this.showMember = true;
      this.$nextTick(() => {
        this.$refs.peopleTable.search({
          level: lv,
          targetName: this.agentName,
          filter: this.computedFilter,
        });
      });
    },
    handleFilterChange(item) {
      this.filter = item;
    },
    handleSearch() {
      this.$store.commit("breadcrumb/clear");
      if (this.searchName) {
        this.showDistributed = false;
        this.showMember = false;
      }
      this.$refs.table.search(this.agentTableRequest);
    },
    addBreadcrumb() {
      this.$store.commit("breadcrumb/add", {
        id: this.$route.name + "_" + this.targetName,
        name: this.$route.name,
        params: {
          username: this.targetName,
        },
        meta: {
          title:
            this.$t("column." + this.targetGroup) + "(" + this.targetName + ")",
        },
      });
    },
    togglePage(hasUser, route) {
      this.showMember = false;

      if (!hasUser) {
        this.targetName = "";
        this.$store.commit("breadcrumb/clear");
      } else {
        this.targetName = route.params.username;
      }

      this.$nextTick(() => {
        this.$refs.table.search(this.agentTableRequest);
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.togglePage(to.params.username, to);

    next();
  },
  watch: {
    hasUser(val) {
      this.togglePage(val, this.$route);
    },
  },
};
</script>
